import { useTranslation } from 'react-i18next';
import { CalendarLayout } from '../components';
import { SYNC_STATUS } from '../constants';
import {
  useSyncSession,
  useSyncStatusPolling,
  useSyncStatusRedirect,
} from '../hooks';
import { SyncingTracking, SyncingUntracked } from './components';
import * as S from '../styles';

export default function CalendarSyncing() {
  const [t] = useTranslation('calendar');

  const session = useSyncSession();
  const { status } = useSyncStatusPolling({ session });
  useSyncStatusRedirect(status);

  return (
    <CalendarLayout compact>
      {status === SYNC_STATUS.untracked ? (
        <SyncingUntracked />
      ) : (
        <SyncingTracking done={status === SYNC_STATUS.ready} />
      )}

      <S.LegalNotice>{t('syncing.trademarks')}</S.LegalNotice>
    </CalendarLayout>
  );
}
